import React from "react";
import {getCommonVisualizerType} from "../../../../config";

const LookIntroAIImageChange = (props) => {

  const {isHidden, isMobile} = props;

  const isBathroom = getCommonVisualizerType() === "bathroom";
  const image1 = isBathroom ? "bv-after.jpg" : "ChatGPT_ai_image_1.png";
  const image2 = isBathroom ? "bv-before.jpg" : "ChatGPT_ai_image_2.png";

  return (
    <div className={"flex flex--center"
      + (isHidden ? " absolute opacity-0 right-full transition2 visibility-hidden" : "")
      + (isMobile ? " fixed h-full left-4 top-0" : " pb-05")} style={isMobile ? {width: "calc(50% - 4rem)"} : null}>
      <div className={"relative" + (isMobile ? " h-full w-full" : "")}>
        <img className={"look-intro__ai-image" + (isMobile ? " h-full w-full" : "")}
             src={`https://qc-cdn.s3.dualstack.us-east-1.amazonaws.com/look/${image2}`} alt=""/>
        <img className={"look-intro__ai-image look-intro__ai-image--animation absolute left-0 top-0 w-full h-full"}
             src={`https://qc-cdn.s3.dualstack.us-east-1.amazonaws.com/look/${image1}`} alt=""/>
      </div>
    </div>
  )
};

export default LookIntroAIImageChange
